import React from 'react';
import {Link} from "react-router-dom";
import Header from '../modules/header'
import $ from "jquery";
import Footerslider from '../components/FooterSlider/footerslider';
import Slider from "react-slick";
import axios from 'axios';

import bannerarw from '../assets/images/icons/banner-arrow.png';
import Twitter from '../assets/images/Main/Twitter.svg';
import Linkedin from '../assets/images/Main/Linkedin.svg';
import Instagram from '../assets/images/Main/Instagram.svg';
import Facebook from '../assets/images/Main/Facebook.svg';
import fantsyland from '../assets/images/yachts/fantsyland-img.png';
import img11 from '../assets/images/yachts/image-11.png';
import vector2 from '../assets/images/Blog/blog-vector2.svg';
import img18 from '../assets/images/yachts/image-18.png';
import caribbeanmob from '../assets/images/yachts/caribbean_mob.png';
import img20 from '../assets/images/yachts/image-20.png';
import img19 from '../assets/images/yachts/image-19.png';
import puresuremob from '../assets/images/yachts/puresore_mobile.png';
import btnarw from '../assets/images/icons/button-arrow.png';
import vector22 from '../assets/images/icons/vector2.png';
import vector4 from '../assets/images/icons/vector4.png';
import img36 from '../assets/images/yachts/image-36.png';
import img1 from '../assets/images/yachts/slider1.png';
import featured_header from '../assets/images/bg/destination_bg.png';
import ModalVideo from './video-modal';
import parse from 'html-react-parser';

class Destination extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeSlide: 0,
            featured_destination: { images: [] },
            destinations: [],
            next_page: 1,
            current_page: 0,
            isOpen: false,
            general_content: {},
            SliderImages:[]

        };

        this.handlePagination = this.handlePagination.bind(this);
        this.openModal = this.openModal.bind(this);
    }

    openModal () {
        if(this.state.featured_destination && this.state.featured_destination.video) {
            this.setState({isOpen: true});
        }
    }

    handlePagination(event) {
        this.loadDestinations();
    }

    loadDestinations() {
        const destination_id = this.props.match.params.id;

        axios.get(`${process.env.REACT_APP_API_URL}/destinations/${destination_id}?page=${this.state.next_page}.json`)
        .then((response) => {
            
            if(response.data.current_page === 1) {
                this.setState({ destinations: response.data.destinations })
            } else {
                this.setState({ 
                    destinations: this.state.destinations.concat(response.data.destinations)
                 })
            }

            this.setState({ 
                featured_destination: response.data.featured_destination, 
                next_page: response.data.next_page,
                current_page: response.data.current_page,
            });

            if(response.data.featured_destination && response.data.featured_destination.images){
                let SliderImages = []
                response.data.featured_destination.images.map((image, index) => {
                    SliderImages.push(image.slider.url)
                })
               
                console.log('SliderImages', SliderImages)
                this.setState({SliderImages:SliderImages})
            }
        })
        .catch();
    }
    componentDidMount() {
        window.scrollTo(0, 0)

        axios.get(`${process.env.REACT_APP_API_URL}/content.json`)
        .then((response) => {
            this.setState({ general_content: response.data.general });
            window.scrollTo(0, 0)
        })
        .catch();

        this.loadDestinations();
        $(".arrow-down a")
            .on('click', function (event) {
                if (this.hash !== "") {
                    event.preventDefault();
                    var hash = this.hash;
                    $('html, body').animate({
                        scrollTop: $(hash)
                            .offset()
                            .top
                    }, 800, function () {
                        window.location.hash = hash;
                    });
                }
            });
        // backto top jquery
        if ($('#back-to-top').length) {
            var scrollTrigger = 100, // px
                backToTop = function () {
                    var scrollTop = $(window).scrollTop();
                    if (scrollTop > scrollTrigger) {
                        $('#back-to-top').addClass('show');
                    } else {
                        $('#back-to-top').removeClass('show');
                    }
                };
            backToTop();
            $(window).on('scroll', function () {
                backToTop();
            });
            $('#back-to-top').on('click', function (e) {
                e.preventDefault();
                $('html,body').animate({
                    scrollTop: 0
                }, 700);
            });
        }
    }

    render() {

        const settings = {
            className: "center",
            // centerMode: true,
            infinite: true,
            swipeToSlide :true,
            // centerPadding: "0",
            slidesToShow: 2,
            speed: 500,
            slidesPerRow: 1,
            slidesToScroll: 1,
            focusOnSelect: true,
            dots: true,
            initialSlide: 0,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        slidesPerRow: 1,
                        centerMode: false,
                        arrows: false
                    }
                }
            ],
            beforeChange: (current, next) => this.setState({oldSlide: current, activeSlide: next === -1 ? 0 : next}),
            afterChange: current => this.setState({activeSlide2: current})
        };

        const featured_destination = this.state.featured_destination;
        const destinations = this.state.destinations;

        const backgroundStyle = {
            backgroundImage: `linear-gradient( rgba(0, 0, 0, 0.7) 0%, transparent 20%, transparent 35%, rgba(0, 0, 0, 0.7) 100% ),url(${featured_destination && featured_destination.featured_image ? featured_destination.featured_image.featured.url : ''})`
        }

        return (
            <div
                className="open_menudiv"
                style={{
                'overflowX': 'hidden'
            }}>
                <ModalVideo isOpen={this.state.isOpen} onClose={() => this.setState({isOpen: false})} channel="custom" videoId={ featured_destination && featured_destination.video ? featured_destination.video.url : ''} />
                <Header></Header>

                {/* Hero Section */}
                <div className="hero-slider section destination-hero">
                    <div className="hero-item HRO_SEC" id="destination_pg" style={backgroundStyle}>
                        <div className="slider-dark-overlay"></div>
                        <div className="container">
                            <div className="row">
                                <div className="hero-content-wrap col">
                                    <div className="hero-content destination-content">
                                        <div className="row">
                                            <div className="col-lg-7 col-md-6 col order-2 order-lg-1">
                                                <div className="des-content-hero">
                                                    <p className="destina-first">FEATURED</p>
                                                    <h1>{featured_destination.title}</h1>
                                                    <p className="sec_destinatom_p">{featured_destination.description}</p>
                                                </div>
                                            </div>
                                            <div className="col-lg-5 col-md-6 order-1 order-lg-2 video-margin">
                                                {
                                                    this.state.featured_destination && this.state.featured_destination.video && this.state.featured_destination.video.url
                                                    ?
                                                    <div className="video-play destination-video">
                                                        <div id="video_container" className="Videoscreen" onClick={this.openModal} >
                                                            <div className="flex" id="local_image_container">
                                                                <div className="vid htmlvid" id="playicon-charter"></div>
                                                                <p className="watch_videop">Watch our video
                                                                    <br/>about charter</p>
                                                            </div>
                                                        </div>
                                                        <p className="mobile-video-title">Watch our video about charter</p>
                                                    </div>
                                                    :
                                                    false

                                                }
                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="arrow-down">
                            <a href="#fantasyland">
                                <p className="scroll-text">Scroll Down</p>
                                <img src={bannerarw} className="img-responsive" alt="button arrow" />
                            </a>
                        </div>
                        <div className="social-links-top">
                            <ul>
                                <li>
                                    <a href={this.state.general_content && this.state.general_content.fields && this.state.general_content.fields.twitter_link}><img src={Twitter} className="img-responsive" alt="Twitter icon"/></a>
                                </li>
                                <li>
                                    <a href={this.state.general_content && this.state.general_content.fields && this.state.general_content.fields.linkedin_link}><img src={Linkedin} className="img-responsive" alt="Linkedin icon"/></a>
                                </li>
                                <li>
                                    <a href={this.state.general_content && this.state.general_content.fields && this.state.general_content.fields.instagram_link}><img src={Instagram} className="img-responsive" alt="Instagram icon"/></a>
                                </li>
                                <li>
                                    <a href={this.state.general_content && this.state.general_content.fields && this.state.general_content.fields.facebook_link}><img src={Facebook} className="img-responsive" alt="Facebook icon"/></a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                {/* Second section */}
                <section id="fantasyland" className="section fix fantasyland">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6 col-md-6">
                                <div className="fantasyland-content">
                                    <h1>{featured_destination.heading}</h1>
                                    <p>
                                    {featured_destination.intro_content}
                                    </p>
                                    <div className="fantasyland-mobile">
                                        <img src={fantsyland} className="img-responsive" alt="fantsyland" />
                                    </div>
                                    <p className="destina_p_secpara">
                                        {featured_destination.intro_content_2}
                                    </p>
                                </div>
                                <div className="post-author" id="author_destinatoin">
                                    <div className="avatar">
                                        <img src={img11} className="img-responsive" alt="avtar" />
                                    </div>
                                    <p className="desc">{featured_destination.testimonial}
                                    </p>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6">
                                <div className="fantasyland-img" id="fantan_desktop">
                                    <img src={featured_destination.side_image ? featured_destination.side_image.side_image.url : fantsyland} className="img-responsive" alt="fantsyland"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="background-vector offer-news-vector" id="destination_vctr1">
                        <img src={vector2} className="img-responsive" alt="Background vector art"/>
                    </div>
                </section>

                {/* Slider section */}
                <section id="destination-carousel" className="slider_desitnation">
                    <div className="container-fluid">
                        <div className="row desktop-slider">
                            {this.state.SliderImages.length>0?<div className="col-lg-12 col-md-12 no-padding singlepage-carousel">
                                <div>
                                <Slider {...settings}>
                                        {this.state.SliderImages.length>0?
                                        this.state.SliderImages.map((image, i)=>{
                                            return(
                                                <div>
                                                     <img key={i} src={image} className="img-responsive" alt="img responsive" />
                                                </div>
                                            )
                                        }):null
                                        }
                                    </Slider>
                                </div>
                                {
                                    featured_destination && featured_destination.images && featured_destination.images.length > 0
                                    ?
                                    <h4 className="desti_pagin desti_pagination">{this.state.activeSlide < 0 ? 1 : this.state.activeSlide + 1}  / { featured_destination && featured_destination.images && featured_destination.images.length}</h4>
                                    :
                                    false
                                }
                            </div>:null}
                        </div>

                    </div>
                </section>

                {/* Third section */}
                <section
                    id="destinationpage-content"
                    className="section fix destinationpage-content">
                    <div className="container">
                        <div className="row mtp">
                            <div className="col-lg-12 col-md-12 padding-lr">
                                <p className="main-sec_destionp">
                                    {featured_destination.content && parse(featured_destination.content)}
                                </p>
                            </div>
                            {/* <div className="col-lg-6 col-md-6 padding-lr">
                                <p className="main-sec_destionp">
                                    To the north of Fiji lies the remote constellation of the Yasawa Islands.
                                    Boasting over 20 islands, the Yasawa archipelago is the famed film location of
                                    the Blue Lagoon where fringing reefs, crystalline waters and abundant sea life
                                    including, angelfish, butterfly fish and green hawksbill turtles can be found.
                                    South of the island of Fiji lies a collection of uninhabited coves, lustrous
                                    volcanic summits and tumbling waterfalls which make up the island of Kadavu.
                                    This island is a haven for hikers, trekkers and lovers of the outdoors with an
                                    abundance of walks to be had around relatively unexplored sites whilst surfers
                                    and snorkellers alike will revel in the chance to explore the famed Great
                                    Astrolabe and fringing coral reefs.<br/><br/>
                                    Whether you’re looking to wind down in a gently swinging hammock or take to some
                                    of the invigorating water sport opportunities, Fiji is a paradise destination
                                    with something to surpass the expectation of every visitor.
                                </p>
                            </div> */}
                        </div>
                    </div>
                </section>

                {/* Fourth section */}
                <section
                    id="other-gems"
                    className="section fix other-gems destina_gems"
                    data-wow-duration="1s">
                    
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6 col-md-6">
                                <div className="gems-content-div">
                                    <div className="other-gems-cont-left">
                                        <div className="heading">
                                            <h1>Other Gems</h1>
                                            <p>Secret locations around the world</p>
                                        </div>
                                    </div>
                                    { this.state && this.state.destinations && this.state.destinations.map((destination, index) => {
                                        
                                        return ((index+1) === 1) || ((index+1) % 2 === 0 && (index+1) % 3 !== 0)  ? [
                                        <Link to={"/destination/" + destination.id } key={destination.id}>
                                        <div className="col-lg-6 col-md-6">
                                            <div className="gems">
                                                <div className="gems-img"> 
                                                    <img src={destination.featured_image.url} srcSet={`${destination.featured_image.url} 300w, ${destination.featured_image.url} 768w, ${destination.featured_image.url} 1280w`} className="img-responsive" alt="caribbean"/>
                                                </div>
                                                <div className="gems-content">
                                                    <p className="title">{ destination.title }</p>
                                                    <p className="txt">{destination.description}</p>
                                                </div>
                                            </div>
                                        </div>
                                        </Link>
                                        ] : false
                                        
                                    })}
                                    
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6"> 
                                <div className="other-gems-cont-right">
                                    <div className="gems-content-div">
                                        { this.state && this.state.destinations && this.state.destinations.map((destination, index) => {
                                            
                                            return ((index+1) % 3 === 0)  ? [
                                            <Link to={"/destination/" + destination.id } key={destination.id}>
                                            
                                            <div className="col-lg-6 col-md-6">
                                                <div className="gems">
                                                    <div className="gems-img"> 
                                                        <img src={destination.featured_image.url} srcSet={`${destination.featured_image.url} 300w, ${destination.featured_image.url} 768w, ${destination.featured_image.url} 1280w`} className="img-responsive" alt="caribbean"/>
                                                    </div>
                                                    <div className="gems-content">
                                                        <p className="title">{ destination.title }</p>
                                                        <p className="txt">{destination.description}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            </Link>
                                            ] : false
                                            
                                        })}

                                        {
                                        this.state && this.state.next_page == null ? 
                                        false
                                        :
                                        <div className="load-moregems">
                                            <div className="gems-content">
                                                <p className="title">Load more
                                                    <br/>luxury Destination</p>
                                                <p className="txt">Go on... be curious</p>
                                                <button className="btn btn-secondary btn-theme" onClick={this.handlePagination}>
                                                    <span>load more</span>
                                                    <img src={btnarw} className="img-responsive" alt="button arrow" />
                                                </button>
                                            </div>
                                            <div className="vector-img">
                                                <img id="last_destinatio_vector" src={vector22} className="img-responsive" alt="vector" />
                                            </div>
                                        </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* slider section */}
                <Footerslider></Footerslider>
                <a href="#pagetop" id="back-to-top" title="Back to top">&uarr;</a>
            </div>
        );
    }

}

export default Destination;
